<template>
  <v-combobox
    :value="value"
    @change="updateValue"
    :items="items"
    item-value="id"
    item-text="name"
    :label="label"
    :search-input.sync="phrase"
    multiple
    small-chips
  ></v-combobox>
</template>

<script>
import axios from "axios";
import { getTsQueryValue } from "@/utils/common";

export default {
  name: "PublisherCombo",
  props: {
    label: String,
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      items: [],
      phrase: "",
    };
  },
  watch: {
    async phrase(value, oldValue) {
      this.loading = true;
      if (value && value.length > 1 && value !== oldValue) {
        let response = await axios.get("/psql/publishers_view", {
          params: {
            select: "id, name, iso3, geo_name",
            name: getTsQueryValue(value),
            order: `name`,
          },
        });
        this.items = [...response.data];
      }
      this.loading = false;
    },
  },
  methods: {
    updateValue(value) {
      console.log(value);
      this.$emit("input", value);
    },
  },
};
</script>

<style scoped></style>
